import { gql } from "@apollo/client";

export const GET_ALL_DEPOSITO = gql`
query allDeposito($where: DepositoFilterInput){
    allDeposito(where: $where) {
        idDeposito,
        descripcion,
        centroSAP,
        almacenSAP,
        regional
    }
  }
`;